import type { BrandLogoKind } from '../lib/api.js';

export const LOGO_ACCEPT = '.svg,.png,.webp,image/svg+xml,image/png,image/webp';

/// O que cada formato é e o que ele exige, na língua de quem sobe o arquivo (ADR 0040).
export const logoSlots: ReadonlyArray<{
  kind: BrandLogoKind;
  title: string;
  description: string;
  rule: string;
  /// Menor tamanho em pixels aceito para PNG/WebP; o servidor confere de novo.
  minWidth: number;
  minHeight: number;
}> = [
  {
    kind: 'MAIN',
    title: 'Logo principal',
    description: 'Horizontal. Vai no topo dos documentos e no centro do topo da área da empresa.',
    rule: 'SVG, ou PNG/WebP com pelo menos 1200 px de largura.',
    minWidth: 1200,
    minHeight: 0,
  },
  {
    kind: 'SYMBOL',
    title: 'Símbolo',
    description: 'Quadrado. Vai nas páginas seguintes dos documentos e no ícone da aba.',
    rule: 'SVG, ou PNG/WebP com pelo menos 512 × 512 px.',
    minWidth: 512,
    minHeight: 512,
  },
  {
    kind: 'DARK',
    title: 'Logo para fundo escuro',
    description: 'Opcional. Usada no tema escuro no lugar da principal.',
    rule: 'Mesmas regras da logo principal.',
    minWidth: 1200,
    minHeight: 0,
  },
];
